export const withPropertyNamePrefix = <T>(
  object: Record<string, T>,
  prefix = "",
): Record<string, T> => {
  const prefixedEntries = Object.entries(object).map(
    ([key, value]): [string, T] => [`${prefix}${key}`, value],
  );
  return Object.fromEntries(prefixedEntries);
};
